import Model from "./base/model";
import Client from "../http/client";

class   loanQuoteItem extends Model {
  resourceName() {
    return "loan_quote_items";
  }

  fields() {
    return {
      response: "",
      order: { jsonApi: "hasOne", type: "order"},
    };
  }

}


export default new loanQuoteItem();
